import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgInvoice = (props: SvgProps) => (
  <Svg fill="none" height={24} width={24} {...props}>
    <Path
      d="M13 15.7H7a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2m-4-6h2a1 1 0 1 0 0-2H9a1 1 0 0 0 0 2m12 2h-3v-9a1 1 0 0 0-1.5-.87l-3 1.72-3-1.72a1 1 0 0 0-1 0l-3 1.72-3-1.72A1 1 0 0 0 2 2.7v16a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1m-16 8a1 1 0 0 1-1-1V4.43l2 1.14a1.08 1.08 0 0 0 1 0l3-1.72 3 1.72a1.08 1.08 0 0 0 1 0l2-1.14V18.7a3 3 0 0 0 .18 1zm15-1a1 1 0 1 1-2 0v-5h2zm-7-7H7a1 1 0 1 0 0 2h6a1 1 0 0 0 0-2"
      fill={props.color}
    />
  </Svg>
);
const Memo = memo(SvgInvoice);
export default Memo;
